<template>
  <div
    class="search-container d-flex align-items-center"
    @blur="deactivate"
    v-click-outside="deactivate"
    @keydown="handleKeydown"
  >
    <!-- <div class="search" @blur="deactivate" v-click-outside="deactivate" @keydown="handleKeydown"> -->
    <!-- :class="{'form-control-lg': searchActive}" -->
    <input
      ref="searchInput"
      :class="{ inactive: searchActive === false }"
      class="form-control form-control-sm"
      type="text"
      :placeholder="placeholder"
      :value="query"
      @input="search"
      @focus="activate"
      @mousedown="activate"
    />
    <div
      class="dropdown-menu search-results d-flex flex-row"
      v-if="showResults"
    >
      <div class="d-flex flex-column w-100">
        <template v-if="notesFound.length > 0">
          <div>
            <search-result
              v-for="note in notesFound.slice(
                resultOffset,
                resultOffset + resultsPerNote
              )"
              :result="note"
              :active-result="activeResult"
              :current-note="currentNote"
              :query="query"
              :key="note.id"
              @click="goTo(note)"
            ></search-result>
          </div>
          <div
            class="d-flex justify-content-center pagination mt-1"
            v-if="notesFound.length > resultsPerNote"
          >
            <nav aria-label="Search result pages">
              <ul class="pagination justify-content-end my-0">
                <li
                  class="page-item"
                  :class="{ disabled: currentSearchNote === 1 }"
                >
                  <span
                    class="page-link"
                    @click="goToSearchNote(currentSearchNote - 1)"
                    >Previous</span
                  >
                </li>
                <li
                  class="page-item"
                  :class="{ active: currentSearchNote === n }"
                  v-for="n in searchNoteNumbers"
                  :key="n"
                >
                  <span class="page-link" @click="goToSearchNote(n)">{{
                    n
                  }}</span>
                </li>
                <li
                  class="page-item"
                  :class="{ disabled: currentSearchNote === lastSearchNote }"
                >
                  <span
                    class="page-link"
                    @click="goToSearchNote(currentSearchNote + 1)"
                    >Next</span
                  >
                </li>
              </ul>
            </nav>
          </div>
        </template>
        <span class="dropdown-item" v-else>No notes found</span>
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>
<script>
import SearchResult from '@/components/Search/SearchResult'
import EventBus from '@/utils/event-bus'
// import { findNotesByQuery } from '@/utils/api'
import { trackEvent } from '@/utils/analytics'
import goToNote from '@/mixins/go-to-note'
export default {
  components: {
    SearchResult
  },
  mixins: [goToNote],
  data() {
    return {
      query: '',
      inactive: true,
      showResults: false,
      searchActive: false,
      activeResult: {},
      resultOffset: 0,
      resultsPerNote: 10,
      notesFound: []
    }
  },
  mounted() {
    EventBus.$on('activateSearch', () => this.activate())
    this.setActiveResult()
  },
  computed: {
    currentNote() {
      return this.$store.getters.currentNote
    },
    placeholder() {
      return this.searchActive ? 'Start typing to search' : 'Search for notes'
    },
    currentSearchNote() {
      return (this.resultOffset + this.resultsPerNote) / this.resultsPerNote
    },
    lastSearchNote() {
      return Math.ceil(this.notesFound.length / this.resultsPerNote)
    },
    searchNoteNumbers() {
      const numNotes = 5
      const minNote = Math.max(1, Math.min(Math.max(1, this.currentSearchNote - 2), this.lastSearchNote - numNotes + 1))
      const maxNote = Math.min(this.lastSearchNote + 1, minNote + numNotes)
      let notes = []
      for (let i = minNote; i < maxNote; i++) {
        notes.push(i)
      }
      return notes
    }
  },
  methods: {
    search(event) {
      this.query = event.target.value
    },
    goTo(note) {
      if (note.id) {
        this.goToNote(note.id)
        this.deactivate()
      }
    },
    activate() {
      this.searchActive = true
      this.$refs.searchInput.focus()
      this.showResults = true
      this.resultOffset = 0
      this.setActiveResult()
    },
    deactivate(event) {
      this.query = ''
      this.showResults = false
      this.activeResult = {}
      this.searchActive = false
    },
    handleKeydown(event) {
      const code = event.code
      if (['ArrowUp', 'ArrowDown', 'Tab'].includes(code)) {
        const index = this.notesFound.findIndex(p => p.id === this.activeResult.id)
        let newIndex
        const goToNext = code === 'ArrowUp'
        const goToPrevious = ['ArrowDown', 'Tab'].includes(code)
        if (goToNext) {
          newIndex = index - 1
        } else if (goToPrevious) {
          newIndex = index + 1
        }
        if (newIndex < 0) newIndex = this.notesFound.length - 1
        if (newIndex >= this.notesFound.length) newIndex = 0
        this.activeResult = this.notesFound[newIndex]
        this.resultOffset = (this.getNoteByIndex(newIndex) - 1) * this.resultsPerNote
      } else if (code === 'Enter' && this.activeResult) {
        this.goTo(this.activeResult)
        event.preventDefault()
      } else if (code === 'Escape') {
        this.deactivate()
      } else {
        this.activate()
      }
    },
    setActiveResult() {
      if (this.notesFound.length > 0) this.activeResult = this.notesFound[0]
    },
    getNoteByIndex(index) {
      return Math.ceil((index + 1) / this.resultsPerNote)
    },
    goToSearchNote(n) {
      trackEvent('go to note from search', {
        eventCategory: 'search',
        eventAction: 'go_to_note'
      })
      this.resultOffset = (n - 1) * this.resultsPerNote
    }
  },
  watch: {
    searchActive() {
      this.$emit('active', this.searchActive)
      if (this.searchActive) {
        trackEvent('activate search', {
          eventCategory: 'search',
          eventAction: 'activate'
        })
      }
    },
    note() {
      this.query = ''
    },
    notesFound() {
      this.setActiveResult()
    },
    resultOffset() {
      this.activeResult = this.notesFound[this.resultOffset]
    },
    query() {
      this.notesFound = this.$store.getters.notesByQuery(this.query).sort((a, b) => b.modified - a.modified)
    }
  }
}
</script>
<style scoped>
.search-container {
  position: relative;
  /* min-height: calc(2.875rem + 2px); */
}
/* .search {
  position: absolute;
  left: 0;
  right: 0;
} */
/* .search input {
  transition: all 100ms ease;
  transition-property: height, font-size;
} */
input::-webkit-input-placeholder {
  color: #fff !important;
}
input:-moz-placeholder {
  /* Firefox 18- */
  color: #fff !important;
}
input::-moz-placeholder {
  /* Firefox 19+ */
  color: #fff !important;
}
input:-ms-input-placeholder {
  color: #fff !important;
}
.inactive:hover {
  /* border: 1px solid #fff; */
  background-color: #3964db !important;
}
.inactive {
  color: #fff !important;
  background-color: #355fd3 !important;
  border: 0;
}
.search-results {
  left: 0;
  right: 0;
  display: block;
}
.dropdown-item {
  cursor: pointer;
  overflow: hidden;
}
.page-link {
  cursor: pointer;
}
.page-item:focus,
.page-link:focus {
  outline: none;
}
.pagination {
  font-size: 0.9em;
}
</style>
